export const defaultLocale = "en";
export const defaultCurrency = "GEL";